import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'

export default () => {
  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Box display="flex" flexDirection="column" width="400px" mb="20px">
        <Skeleton animation="wave" width="100%" height="40px" />
      </Box>
      <Box display="flex" flexDirection="column" width="600px" mb="20px">
        <Skeleton animation="wave" width="100%" />
        <Skeleton animation="wave" width="100%" />
        <Skeleton animation="wave" width="100%" />
      </Box>

      <Box display="flex" flexDirection="column" width="100%">
        <Skeleton animation="wave" width="100%" />
        <Skeleton animation="wave" width="100%" />
        <Skeleton animation="wave" width="100%" />
        <Skeleton animation="wave" width="100%" />
      </Box>
      <Box display="flex" flexDirection="column" width="100%">
        <Skeleton animation="wave" width="100%" />
        <Skeleton animation="wave" width="100%" />
        <Skeleton animation="wave" width="100%" />
        <Skeleton animation="wave" width="100%" />
      </Box>
      <Box display="flex" flexDirection="column" width="100%">
        <Skeleton animation="wave" width="100%" />
        <Skeleton animation="wave" width="100%" />
        <Skeleton animation="wave" width="100%" />
        <Skeleton animation="wave" width="100%" />
      </Box>
    </Box>
  )
}
